
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/technology-deployment/cyber-security",
      function () {
        return require("private-next-pages/expertise/technology-deployment/cyber-security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/technology-deployment/cyber-security"])
      });
    }
  